<script lang="ts" setup>
import { computed, ComputedRef } from 'vue';

import { UserModel } from '@/types';
import { useAuthStore } from '@/stores';

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);
</script>

<template>
    <div class="bg-black/20 p-4">
        <div class="flex items-center" v-if="user !== undefined">
            <div>
                <UiGravatar
                    :email="user.email"
                    :name="user.name"
                    class="inline-block h-10 w-10 rounded-full"
                />
            </div>
            <div class="ml-4">
                <p class="text-sm font-medium text-white">{{ user.name }}</p>
            </div>
        </div>
    </div>
</template>
